import { makeName, makeTitle } from "./SubscribeButtonUtils";

const SubscribeButtonConfigs = (name, hashtag) => [
  {
    label: "subscribe",
    hoverLabel: "login",
    name: "subscribe_login",
    title: "Login to subscribe.",
    action: "login",
  },
  {
    type: "hashtag",
    subscription: 1,
    label: "subscribed",
    hoverLabel: "unsubscribe",
    action: "delete",
    name: makeName("unsubscribe", null, hashtag),
    title: makeTitle("Unsubscribe", null, hashtag),
  },
  {
    type: "hashtag",
    subscription: 0,
    label: "subscribe",
    hoverLabel: "subscribe",
    action: "post",
    name: makeName("subscribe", null, hashtag),
    title: makeTitle("Subscribe", null, hashtag),
  },
  {
    type: "user",
    subscription: "is_private",
    label: "subscribe",
    hoverLabel: "request",
    action: "post",
    name: makeName("request", name),
    title: makeTitle("Request subscription", name),
  },
  {
    type: "user",
    subscription: "is_public",
    label: "subscribe",
    action: "post",
    name: makeName("subscribe", name),
    title: makeTitle("Subscribe", name),
  },
  {
    type: "user",
    subscription: "is_private_requested",
    label: "requested",
    hoverLabel: "cancel",
    action: "delete",
    name: makeName("cancel_request", name),
    title: makeTitle("Cancel subscription request", name),
  },
  {
    type: "user",
    subscription: "is_public_requested",
    label: "requested",
    hoverLabel: "cancel",
    action: "delete",
    name: makeName("cancel_request", name),
    title: makeTitle("Cancel subscription request", name),
  },
  {
    type: "user",
    subscription: "is_private_subscribed",
    label: "subscribed",
    hoverLabel: "unsubscribe",
    action: "delete",
    name: makeName("unsubscribe", name),
    title: makeTitle("Unsubscribe", name),
  },
  {
    type: "user",
    subscription: "is_public_subscribed",
    label: "subscribed",
    hoverLabel: "unsubscribe",
    action: "delete",
    name: makeName("unsubscribe", name),
    title: makeTitle("Unsubscribe", name),
  },
];

export default SubscribeButtonConfigs;
